<app-stages [stages]="stages" currentStage="Dane wniosku">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
    @if (placeOfFillingDeclarationInfo) {
      <div class="row">
        <div class="col-md-6">
          <div class='form-group'>
            <label [for]='placeOfFillingDeclarationInfo'>
              Miejsce składania deklaracji *
            </label>
            <input
              value="Urząd Gminy Długołęka ul. Robotnicza 12 55-095 Długołęka"
              readonly
              [id]='placeOfFillingDeclarationInfo'
              type='text'>
          </div>
        </div>
      </div>
    }
    <div class='row'>
      @if (form.applicationSubject) {
        <div class='col-12' *ngIf='applicationSubjectControlType === "label"'>
          <app-label class="mb-4" [label]="(application() | applicationSubjectLabel) + ':'">
            {{ form.applicationSubject.value || '-' }}
          </app-label>
        </div>
      }
      @if (form.applicationSubject) {
        <div class='col-md-4' *ngIf='applicationSubjectControlType === "text"'>
          <div class='form-group' *ngIf='"applicationSubject" as controlName'>
            <label [for]='controlName'>
              {{ application() | applicationSubjectLabel }} *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              [placeholder]='application() | applicationSubjectPlaceholder'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4' *ngIf='applicationSubjectControlType === "select"'>
          <div class='form-group' *ngIf='"applicationSubject" as controlName'>
            <label [for]='controlName'>
              {{ application() | applicationSubjectLabel }} *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of applicationSubjectOptions; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12"></div>
      }
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"office" as controlName'>
          <label [for]='controlName'>
            Wniosek składany do *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Urząd'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.documentReceiptMethod) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"documentReceiptMethod" as controlName'>
            <label [for]='controlName'>
              Sposób odbioru *
            </label>
            <select
              (change)="form.documentReceiptMethodChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item?.id' *ngFor='let item of receiptMethods()'>
                {{ item.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.documentReceiptMethod?.value === '2d8f8c02-14f2-428f-beae-6faadbc75170') {
        <div class="col-12">
          <app-alert [closable]="false">
            Pracownik merytoryczny poinformuje telefonicznie o możliwości odbioru przygotowanych dokumentów.<br />Przy odbiorze należy okazać dokument tożsamości.
          </app-alert>
        </div>
      }
      @if (form.ePuapAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"ePuapAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-puap *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu pełny adres skrzynki E-puap'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.eDeliveryAddress) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"eDeliveryAddress" as controlName'>
            <label [for]='controlName'>
              Adres skrzynki E-doręczeń *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu adres skrzynki E-doręczeń'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class="row">
      @if (form.issuedDocumentType) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"issuedDocumentType" as controlName'>
            <label [for]='controlName'>
              Typ wydawanego dokumentu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of issuedDocumentTypes'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.documentIssuePurpose) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"documentIssuePurpose" as controlName'>
            <label [for]='controlName'>
              {{ application() | documentIssuePurposeLabel }} *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              [placeholder]='application() | documentIssuePurposePlaceholder'
              type='text'>
            <app-validation-errors [showTextLength]="true" [maxTextLength]="200" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class='row'>
      @if (form.actType; as actTypeControl) {
        @if (actTypeControl.enabled) {
          <div class="col-md-4">
            <div class='form-group' *ngIf='"actType" as controlName'>
              <label [for]='controlName'>
                Rodzaj aktu planowania przestrzennego *
              </label>
              <select
                (change)="form.deviceTypeChange(form.getElement($event).value)"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of actTypes(); track $index) {
                  <option [value]='item'>
                    {{ item }}
                  </option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        } @else {
          <div class="col-12">
            <app-label label="Rodzaj aktu planowania przestrzennego:">
              {{ actTypeControl.value }}
            </app-label>
          </div>
        }
      }
      @if (form.deviceType) {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"deviceType" as controlName'>
            <label [for]='controlName'>
              Rodzaj urządzenia *
            </label>
            <select
              (change)="form.deviceTypeChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.deviceTypes'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.applicationConcernsStreet) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"applicationConcernsStreet" as controlName'>
            <label [for]='controlName'>
              Wniosek dotyczy ulicy *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.legalInterest) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"legalInterest" as controlName'>
            <label [for]='controlName'>
              Interes prawny *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz interes'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.deviceTypeDescription) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"deviceTypeDescription" as controlName'>
            <label [for]='controlName'>
              Opis rodzaju urządzenia *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz rodzaj urządzenia'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.networkTypeDescription) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"networkTypeDescription" as controlName'>
            <label [for]='controlName'>
              Opis rodzaju sieci lub przyłącza *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz rodzaj sieci lub przyłącza'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (!!form.comments) {
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"comments" as controlName'>
            <label [for]='controlName'>
              Uwagi
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tutaj uwagi'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.showResponsiblePersonControls()) {
      <fieldset>
        <legend>Osoba odpowiedzialna</legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonFirstName" as controlName'>
              <label [for]='controlName'>
                Imię *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu imię'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonLastName" as controlName'>
              <label [for]='controlName'>
                Nazwisko *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwisko'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonPhone" as controlName'>
              <label [for]='controlName'>
                Nr telefonu
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu numer telefonu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"responsiblePersonEmail" as controlName'>
              <label [for]='controlName'>
                E-mail
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu e-mail'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
    @if (form.showManagerControls()) {
      <fieldset>
        <legend>Kierownik robót</legend>
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"managerFirstName" as controlName'>
              <label [for]='controlName'>
                Imię *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu imię'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"managerLastName" as controlName'>
              <label [for]='controlName'>
                Nazwisko *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwisko'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"managerPhone" as controlName'>
              <label [for]='controlName'>
                Nr telefonu *
              </label>
              <input
                mask="0*"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu numer telefonu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"managerEmail" as controlName'>
              <label [for]='controlName'>
                E-mail
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu e-mail'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
    @if (form.unrelatedDeviceForm) {
      <app-unrelated-device-form [form]="form.unrelatedDeviceForm">
      </app-unrelated-device-form>
    }
    @if (form.correspondenceForm; as correspondenceForm) {
      <app-correspondence-form [form]="correspondenceForm">
      </app-correspondence-form>
    }
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
